import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/contexts/LanguageContext";

export default function Subscription() {
  const { tr } = useLang();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <div className="pfi-overline">{tr("membership_eyebrow")}</div>
        <h1 className="mt-3 font-serif text-3xl sm:text-4xl">{tr("sub_page_title")}</h1>
        <p className="mt-2 text-[#a9a9b8] text-sm">{tr("academy_membership_note")}</p>

        <div className="mt-8 pfi-card p-8" data-testid="sub-configuring-card">
          <div className="pfi-overline">{tr("membership_eyebrow")}</div>
          <h2 className="mt-3 font-serif text-2xl text-[#e6c687]" data-testid="sub-configuring-title">
            {tr("membership_title")}
          </h2>
          <p className="mt-3 text-[#a9a9b8] leading-relaxed max-w-2xl">{tr("membership_body")}</p>

          <div className="mt-8 pfi-divider" />

          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="sub-benefits">
            {[
              tr("membership_benefit_ai"),
              tr("membership_benefit_academy"),
              tr("membership_benefit_profile"),
              tr("membership_benefit_history"),
            ].map((b, i) => (
              <div key={i} className="flex items-center gap-3 rounded-xl px-4 py-3 border border-white/5">
                <span className="h-6 w-6 rounded-full grid place-items-center bg-[#d4af37]/15 text-[#e6c687] text-xs">✓</span>
                <span className="text-sm text-[#f8f8fc]">{b}</span>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
